import React from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import { getDateFormat, getOnlyDateFormat } from '../../date-display/date-display';
import { RangePickerProps } from 'antd/lib/date-picker/generatePicker';
import classnames from 'classnames';

const { RangePicker } = DatePicker;

interface Translations {
	today?: string;
	last7Days?: string;
	thisMonth?: string;
	todayAndTomorrow?: string;
	thisWeek?: string;
	fromDate: string;
	toDate: string;
}

const rangeOptions = {
	today: [moment().startOf('day'), moment().endOf('day')],
	last7Days: [moment().subtract(7, 'd').startOf('day'), moment().endOf('day')],
	thisMonth: [moment().startOf('month'), moment().endOf('month')],
	todayAndTomorrow: [moment().startOf('day'), moment().add(1, 'd').endOf('day')],
	thisWeek: [moment().startOf('week'), moment().endOf('week')]
};

export type DateRangePickerProps = {
	startDate: string | Moment;
	endDate: string | Moment;
	translations: Translations;
	onChange: (date: null | Moment[]) => void;
	hourFormat?: string;
	className?: string;
	label?: string;
} & RangePickerProps<Moment>;

const DateRangePickerWrapper: React.FunctionComponent<DateRangePickerProps> = (props: DateRangePickerProps) => {
	const { hourFormat, onChange, translations, className, startDate, endDate, label, ...otherProps } = props;

	const formatDate = (date: string | Moment): Moment | undefined => {
		// do not delete, it create a bug when returning moment of moment!
		if (moment.isMoment(date)) {
			return date;
		}
		return date ? moment(date) : undefined;
	};

	const getRanges = () => {
		const ranges = {} as any;

		Object.entries(rangeOptions).forEach(([rangeType, rangeValue]) => {
			if (translations[rangeType]) {
				ranges[translations[rangeType]] = rangeValue;
			}
		});

		return ranges;
	};

	return (
		<div className={classnames('filter-item', className)}>
			{label && <label className="filters-search-label">{label}:</label>}
			<RangePicker
				allowEmpty={[true, true]}
				format={hourFormat ? getDateFormat(hourFormat) : getOnlyDateFormat()}
				onChange={onChange}
				value={[formatDate(startDate), formatDate(endDate)]}
				placeholder={[translations.fromDate, translations.toDate]}
				ranges={getRanges()}
				{...otherProps}
				className="bringg-picker"
				popupClassName={`bringg-picker-dropdown  ${otherProps.dropdownClassName || ''}`}
			/>
		</div>
	);
};

export default DateRangePickerWrapper;
